import axios from 'axios';
import { toast } from 'react-toastify';

// Add request interceptor

// Add response interceptor
axios.interceptors.response.use(
    (response) => {
        // You can handle and modify the response data here if needed
        const { config, status } = response;
        const { method } = config;
        // You can handle and modify the response data here if needed
        if (method === 'post' || method === 'delete' || method === 'put' || method === 'patch') {
            const successMessage = response?.data?.message || response?.data?.desc || 'Operation successful';
            toast.success(successMessage);
        }

        return response;
    },
    (error) => {
        const { config } = error.response;

        const { method } = config;

        if (
            error.response &&
            error.response.status === 401 &&
            (error.response.data.desc === 'Unauthorized' ||
                error.response.data.desc === "Couldn't verify your identity, please try logging in again" ||
                error.response.data.desc === 'You are not authorized' ||
                error.response.data.desc === "Couldn't find your account, please create an account")
        ) {
            toast.error('Your session has expired. Please log in again');
            document.getElementById('logout-btn')?.click();
            localStorage.clear();
            if (window.location.pathname.toLowerCase().includes('/admin')) {
                window.location.href = '/admin/login';
            }
            if (window.location.pathname.toLowerCase().includes('parker')) {
                window.location.href = '/parker/auth';
            }
        }

        if (method === 'post' || method === 'delete' || method === 'put' || method === 'patch') {
            // You can handle errors here, e.g., show a toast message, logout on certain errors, etc.
            const errorMessage = error?.response?.data?.desc || error?.response?.data?.message || error?.message;
            toast.error(errorMessage);
        }
        return Promise.reject(error);
    }
);

const axiosWrapper = async (method, url, data, token, isFormData = false) => {
    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    try {
        const config = {
            method,
            url,
            ...axiosConfig
        };
        if (token) config.headers['Authorization'] = `Bearer ${token}`;
        if (isFormData) {
            config.headers['Content-Type'] = 'multipart/form-data';
            config.data = data; // Use FormData directly for FormData requests
        } else {
            if (data) config.data = data;
        }

        const response = await axios(config);
        return response.data;
    } catch (error) {
        throw error?.response?.data?.message || error?.message;
    }
};

export default axiosWrapper;
